module.exports = __webpack_public_path__ + "static/img/5.ac96112.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/store_files/images/hoopstack/5.jpg
// module id = 8Tqb
// module chunks = 0